import { InterviewStatus } from "components/CandidateView";
import {PositionProps, SkillsProps} from "../../utils/types";

export enum JobBoardDetailTab {
    newOrViewed = "newOrViewed",
    shortlisted = "shortlisted",
    hideCandidates = "hideCandidates",
}

export enum ApplicationStatus {
    posted = 0,
    viewed = 1,
    opened = 2,
    revealed = 3,
    removed = 4,
    shortlisted = 5,
    declined = 6
}

export type Application = {
    applicationId: number,
    hygienistId: number,
    hireResumeUrl: string,
    name: string,
    firstName?: string, // Add firstName field for initials/full name
    lastName?: string,  // Add lastName field for initials/full name
    type: number, // This is the primary definition for hygienist type
    graduation: string
    yearsOfExperience: string
    rating?: number, // Optional - star rating value
    ratingCount?: number, // Optional - number of ratings
    ratings_num?: number, // Alternative field name for rating count
    ratingsNum?: number, // Alternative field name for rating count
    reviewsCount?: number, // Alternative field name for rating count
    completedJobs?: number, // Alternative field name for rating count
    status: ApplicationStatus,
    interviewStatus: InterviewStatus,
    distance: string,
    school: string,
    resumeViewed: number,
    graduationYear: number,
    firstLicensedYear?: number | null,
    firstLicensedMonth?: number | null,
    showContacts: boolean
    /** Compatibility-only legacy field; never use for membership presentation. */
    hygienistStatus?: number
    /** Canonical server-provided membership authority for candidate presentation. */
    membershipStatusCode?: string | null
    about?: string | null,
    skills?: SkillsProps[];
    photoUrl?: string
    workExperience?: PositionProps[];
    city?: string; 
    province?: string; 
};
